import type { DataTableColumn } from '@/components/custom/erp';
import type { TinhThanh } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<TinhThanh>[] => [
  {
    field: 'ma_tinh',
    headerName: 'Mã tỉnh/thành',
    width: 200
  },
  {
    field: 'ten_tinh',
    headerName: 'Tên tỉnh/thành',
    width: 320
  }
];
